import { Quote } from "lucide-react";
import { Reveal, SectionTag, SectionHeading } from "./Reveal";

const TESTIMONIALS = [
  {
    quote:
      "No complaints — I'm extremely grateful to the CSR reps who help with more than just the job itself, like communicating with vendors directly for RAs and backorders. We didn't have that support before.",
    name: "M. Long",
    title: "Sales Rep",
    testId: "testimonial-quote-item-01",
  },
  {
    quote: "I work closely with the team and they are fabulous! Much appreciated!",
    name: "J. Glasscott",
    title: "Client Partner",
    testId: "testimonial-quote-item-02",
  },
  {
    quote: "Overall, my experience with Artwork360 has been very positive.",
    name: "C. Graphenteen",
    title: "Client Partner",
    testId: "testimonial-quote-item-03",
  },
];

const Testimonials = () => (
  <section id="testimonials" className="bg-[#F8FAFC] py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-5 sm:px-8">
      <SectionTag index="06" label="Testimonials" testId="testimonials-section-tag" />
      <div className="mt-6 max-w-2xl">
        <SectionHeading>What distributors say about the team</SectionHeading>
      </div>

      <div className="mt-16 grid grid-cols-1 gap-6 lg:grid-cols-3">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={t.name} delay={i * 0.12}>
            <figure
              data-testid={t.testId}
              className="flex h-full flex-col rounded-2xl border border-slate-200 bg-white p-8 transition-all duration-500 hover:-translate-y-1.5 hover:border-[#6DC8F0]/30"
            >
              <Quote className="h-7 w-7 text-[#2E3192]/70" />
              <blockquote className="mt-5 flex-1 text-sm leading-relaxed text-slate-600 sm:text-base">
                "{t.quote}"
              </blockquote>
              <figcaption className="mt-7 border-t border-slate-200 pt-5">
                <p className="font-display text-sm font-bold text-slate-900">{t.name}</p>
                <p className="mt-0.5 font-mono2 text-[10px] uppercase tracking-[0.2em] text-slate-500">
                  {t.title}
                </p>
              </figcaption>
            </figure>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
